module.exports = __webpack_public_path__ + "static/media/ac5.31918c50.jpg";